import React from 'react';
import SchemaManager from '../../components/SchemaManager';

const AdminEvents = () => {
  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Évènements</h2>
        <small className="text-muted">
          Gérer les évènements du site
        </small>
      </div>
      
      <SchemaManager
        schemaKey="events"
        endpoint="/api/events"
      />
    </div>
  );
};

export default AdminEvents;